<template>
  <div>
    <div class="result-page" v-show="isLoaded">
      <div class="result-body col-center">
        <md-icon :name="icon" class="icon"></md-icon>
        <p class="text row-center">{{ msg }}</p>
      </div>
    </div>

  <!-- 托管资产确认弹窗-->
  <md-dialog
      :title="this.$t('common.escrowConfirmTitle')"
      :closable="false"
      v-model="escrowDialog.open"
      :btns="escrowDialog.btns"
    >
        {{ $t('common.escrowConfirmText0')  }}<br/>

        <span>{{ $t('common.mixinIDTitle') }}</span>
        <span style="font-weight:bold;color:darkblue;">
        {{$t('common.robotMixinID')}} 
        </span>  
        <span>{{ $t('common.nameTitle') }}</span>
        <span style="font-weight:bold;color:darkblue;">
        {{$t('common.robotName')}} 
        </span>  
        <br/>

        <span>{{$t('common.escrowConfirmText1')}}</span>
      
    </md-dialog>

  <!-- 释放资产确认弹窗-->
   <md-dialog
      :title="this.$t('common.releaseConfirmTitle')"
      :closable="false"
      v-model="releaseDialog.open"
      :btns="releaseDialog.btns"
    >

       <span style="font-weight:bold;color:black;">
        {{$t('common.releaseConfirmText0')}}
        </span>  

        {{$t('common.releaseConfirmText1')}}
   
        <span style="font-weight:bold;color:red;">
        {{releaseDialog.randCode}}
        </span>   

     <md-codebox
      v-model="releaseDialog.code"
      :maxlength="4"
      autofocus
      is-view
      justify
    />
    </md-dialog>


  </div>
</template>

<script>
import { Icon, Toast, Dialog,Codebox } from 'mand-mobile';
import postOrderResult from '@/api/post-order-result';
import { getMixinAuth } from '@/api/user';
export default {
  components: {
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [Codebox.name]: Codebox,
  },
  data() {
    return {
      orderId: '',
      rAction: '',
      isLoaded: false,
      icon: '',
      msg: '',
      releaseDialog: {
        randCode: '',
        code: '',
        path: '',
        method: '',
        open: false,
        btns: [
          {
            text: this.$t('result.close'),
            handler: this.onCancelButton,
          },
          {
            text: this.$t('common.confirm'),
            warning: true,
            handler: this.onReleaseConfirm,
          },
        ],
      },
      escrowDialog: {//托管资产弹窗窗口
        path: '',
        method: '',
        open: false,
        btns: [
          {
            text: this.$t('result.close'),
            handler: this.onCancelButton,
          },
          {
            text: this.$t('common.confirmPayEscrow'),
            warning: true,
            handler: this.onEscrowConfirm,
          },
        ],
      },
    };
  },
  mounted() {
    this.releaseDialog.randCode = Math.floor(Math.random() * 9000) + 1000;
    const query = this.$route.query;
    const id = query.id;
    const action = query.action;
    this.orderId = id;
    this.rAction = action;
    this.isLoaded = false;
    if (!id || !action) {
      this.icon = 'warn-color';
      this.msg = this.$t('error.para');
      this.isLoaded = true;
      return;
    }
    new Promise((resolve, reject) => {
      let obj;
      if (action == 'cancel_paid' || action == 'cancel') {
        obj = {
          icon: 'warn',
          title: this.$t('result.cancelContent'),
          cancelText: this.$t('result.close'),
          confirmText: this.$t('result.cancelTransaction'),
          onConfirm: resolve,
          onCancel: reject,
        };
      }
      if (action == 'escrow_direct') { //支付托管前加一个提醒确认
        this.escrowDialog.open = true;
        return;
      }
      if (action == 'not_received') {
        obj = {
          icon: 'warn',
          title: this.$t('result.notReceivedContent'),
          cancelText: this.$t('result.close'),
          confirmText: this.$t('common.confirm'),
          onConfirm: resolve,
          onCancel: reject,
        };
      }
      if (action == 'pay_assets') {
        obj = {
          icon: 'warn',
          title: this.$t('result.transferAlert'),
          cancelText: this.$t('result.close'),
          confirmText: this.$t('common.confirm'),
          onConfirm: resolve,
          onCancel: reject,
        };
      }
      if (action == 'release') {//释放资产 action时 弹自定义窗口提醒
        this.releaseDialog.open = true;
        return;
      }
      if (obj) {
        Dialog.confirm(obj);
      } else {
        resolve();
      }
    })
      .then(() => {
        Toast.loading(this.$t('common.loading'));
        postOrderResult(id, action)
          .then(data => {
            Toast.hide();
            this.icon = 'success-color';
            this.msg = data.message;
            this.isLoaded = true;
            // const url = data.data.mixin_url; //改为直接返回url
            // if (url) {
            //   window.location.replace(`${url}`);
            // }
          })
          .catch(err => {
            Toast.hide();
            if (err.code == '1075') {
              return Dialog.confirm({
                icon: '',
                title: err.message,
                cancelText: this.$t('common.cancel'),
                confirmText: this.$t('common.reauthorize'),
                onConfirm: () => {
                  getMixinAuth()
                    .then(data => {
                      return window.location.replace(data.data.url);
                    })
                    .catch(err => {
                      Toast.failed(err.message);
                    });
                },
              });
            }
            this.isLoaded = true;
            this.icon = 'wrong';
            this.msg = err.message || this.$t('error.unknown');
          });
      })
      .catch(() => {});
  },
  methods: {
    onCancelButton() {
      Toast.failed(this.$t('common.cancelNeedClosePage'));
    },
    onReleaseConfirm() { //弹窗确认按钮
      if(this.releaseDialog.code == this.releaseDialog.randCode){
        this.releaseDialog.open = false;
        Toast.loading(this.$t('common.loading'));
        postOrderResult(this.orderId, this.rAction)
          .then(data => {
            Toast.hide();
            this.icon = 'success-color';
            this.msg = data.message;
            this.isLoaded = true;
            // const url = data.data.mixin_url; //改为直接返回url
            // if (url) {
            //   window.location.replace(`${url}`);
            // }
          })
          .catch(err => {
            Toast.hide();
            if (err.code == '1075') {
              return Dialog.confirm({
                icon: '',
                title: err.message,
                cancelText: this.$t('common.cancel'),
                confirmText: this.$t('common.reauthorize'),
                onConfirm: () => {
                  getMixinAuth()
                    .then(data => {
                      return window.location.replace(data.data.url);
                    })
                    .catch(err => {
                      Toast.failed(err.message);
                    });
                },
              });
            }
            this.isLoaded = true;
            this.icon = 'wrong';
            this.msg = err.message || this.$t('error.unknown');
          });
      }else{
        Toast.failed(this.$t('common.releaseCodeError'));
      }
    },
    onEscrowConfirm() { //托管弹窗确认按钮
      this.escrowDialog.open = false;
      Toast.loading(this.$t('common.loading'));
      postOrderResult(this.orderId, this.rAction)
        .then(data => {
          Toast.hide();
          this.icon = 'success-color';
          this.msg = data.message;
          this.isLoaded = true;
          const url = data.data.mixin_url; //改为直接返回url
          if (url) {
            window.location.replace(`${url}`);
          }
        })
        .catch(err => {
          Toast.hide();
          if (err.code == '1075') {
            return Dialog.confirm({
              icon: '',
              title: err.message,
              cancelText: this.$t('common.cancel'),
              confirmText: this.$t('common.reauthorize'),
              onConfirm: () => {
                getMixinAuth()
                  .then(data => {
                    return window.location.replace(data.data.url);
                  })
                  .catch(err => {
                    Toast.failed(err.message);
                  });
              },
            });
          }
          this.isLoaded = true;
          this.icon = 'wrong';
          this.msg = err.message || this.$t('error.unknown');
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.result-page {
  .result-body {
    padding-top: 32vw;
    width: 100%;
  }

  .icon {
    font-size: 30vw;
    icon-size(30vw);
  }

  .text {
    margin: 9.6vw 9.6vw 0;
    font-size: 6.4vw;
  }
}

>>>.md-number-keyboard-container .keyboard-number{
 background:transparent;
}
>>>.md-number-keyboard-container::after {
  border-top: transparent;
}
</style>
